export * from './StringToMuiIcon'
